import {
  entityColorsToSimpleVariantColors,
  variantColorsToSimpleVariantColors,
} from '@components/Theme'
import { alpha } from '@mui/material/styles'

import type { AppPaletteOptions, ThemeColors } from './types'

export const createPalette = (colors: ThemeColors): AppPaletteOptions => ({
  // MUI ships neutral black/white washes here, but ~35 call sites read
  // `action.*` as ordinary surface tokens, so they are defined from the ramp:
  // neutral for resting surfaces, teal for selection and keyboard focus.
  action: {
    active: colors.checkbox.default,
    disabled: colors.disabled,
    disabledBackground: colors.main[5],
    focus: alpha(colors.active[1], 0.22),
    hover: colors.main[5],
    selected: alpha(colors.active[1], 0.12),
  },
  alert: colors.alert,
  app: colors,
  background: colors.background,
  divider: colors.divider,
  entity: colors.entity,
  error: {
    main: colors.errorAction[1],
  },
  mode: colors.theme,
  primary: {
    // The canvas colour, not white: it is the far end of the ramp from
    // `active[1]` in BOTH themes (near-white on light's teal-600, near-black on
    // dark's teal-400), so a `primary.main` fill keeps a legible label without a
    // per-theme branch. White on dark's cyan is 1.8:1.
    contrastText: colors.background.default,
    dark: colors.activeEmphasis,
    main: colors.active[1],
  },
  secondary: {
    contrastText: colors.background.default,
    main: colors.main[3],
  },
  success: {
    main: colors.success.dark,
  },
  text: {
    disabled: colors.main[4],
    primary: colors.main[1],
    secondary: colors.main[3],
  },
  textHighlighted: {
    active: colors.active[1],
    inactive: colors.highlightInactive.default,
  },
  textHint: colors.main[3],
  variants: {
    ...entityColorsToSimpleVariantColors(colors.entity),
    error: variantColorsToSimpleVariantColors(colors.error),
    info: variantColorsToSimpleVariantColors(colors.info),
    success: variantColorsToSimpleVariantColors(colors.success),
    warning: variantColorsToSimpleVariantColors(colors.warning),
  },
})
